import { Tooltip } from '../Tooltip/Tooltip';
import DownloadTray from '../../assets/icons/downloadTray.svg?react';
import { IconButton } from '../Button/Button';

export type DownloadFileButtonProps = {
  downloadUrl: string;
  className?: string;
};

/**
 * Button for downloading a file, styled as an IconButton.
 */
export const DownloadFileButton = ({ downloadUrl, className }: DownloadFileButtonProps) => {
  return (
    <Tooltip content="Download">
      <IconButton href={downloadUrl} download className={className}>
        <DownloadTray title="" />
      </IconButton>
    </Tooltip>
  );
};
